<template>
  <div style="height: 100%">
    <!--  任务  -->
    <div :class="showAss==1?'god':'god1'">
      <div class="q-pa-sm">

        <div class="work1" v-show="showAss==1">
          <div class="work">
            <template>
              <el-tabs v-model="activeName" @tab-click="getTasks2(activeName)">
                <el-tab-pane label="全部任务" name="1"></el-tab-pane>
                <el-tab-pane label="我负责的项目" name="2"></el-tab-pane>
                <el-tab-pane label="我参与的项目" name="3"></el-tab-pane>
              </el-tabs>
            </template>
            <div class="caozuo">
              <span @click="showAss=1">任务</span> &nbsp;&nbsp; <span
                style="color:#ebedf0;font-size: 20px;font-weight: 100">|</span>&nbsp;&nbsp;
               <span @click="clickto()">甘特图</span>&nbsp;&nbsp;
              <el-button v-if="user == 1 || users2.indexOf(user) != -1" type="primary" icon="el-icon-plus"
                @click="editColumn" class="btn-submit">新增
              </el-button>
            </div>
          </div>
          <div style="background-color: #ffffff">
            <!--                          :row-class-name="tableRowClassName"  -->
            <el-table :show-header="showHeader" :data="tableData" style="width: 100%">
              <el-table-column prop="status" label="" align="center" width="180">
                <template slot-scope="scope">
                  <!--                  :class="scope.row.status == 1 ? 'begin1' : scope.row.status == 2 ? 'jingxing1': 'finished1' "-->
                  <span
                    :class="thStatus == 2 && scope.row.status==1 ? 'begin1' : thStatus == 2 && scope.row.status==2 ? 'jingxing1' : thStatus == 2 && scope.row.status==3 ? 'finished1' : 'elseTask'"
                    :style="{backgroundColor:scope.row.staColor}">
                    <!--                  {{ scope.row.status == 1 ? '未开始' : scope.row.status == 2 ? '进行中' : scope.row.status == 3 ? '已完成' : staName }}-->
                    {{ scope.row.staName }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="">
                <template slot-scope="scope">
                  <span :class="scope.row.status == 3 ? 'finished2' : '' " style="cursor: pointer"
                    @click="open(scope.row.id)">
                    {{ scope.row.name }}</span>

                </template>
              </el-table-column>

              <el-table-column prop="end_time" width="380" label="">
                <template slot-scope="scope">
                  <span :class="scope.row.status == 3 ? 'finished2' : 'redfont' ">
                    截止时间：{{ scope.row.end_time }}
                  </span>
                  <span v-show="scope.row.status==3" style="padding-left:20px" class="finished2">
                    完成时间：{{ scope.row.finish_time }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="charger_avatar" label="" align="right" width="80">
                <template slot-scope="scope">
                  <el-image :src="'https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png'"
                    style="height: 40px;width:40px;border-radius: 50%"
                    v-if="scope.row.charger_avatar==''||scope.row.charger_avatar==undefined"></el-image>
                  <el-avatar
                    :src="scope.row.charger_avatar.substr(0,4) == 'http' ? scope.row.charger_avatar : $url.img + scope.row.charger_avatar"
                    :key="scope.row.charger_avatar.substr(0,4) == 'http' ? scope.row.charger_avatar : $url.img + scope.row.charger_avatar"
                    v-else></el-avatar>&nbsp;&nbsp;&nbsp;

                </template>
              </el-table-column>
              <el-table-column width="140" align="left" prop="charger_name" label="">
              </el-table-column>
              <el-table-column prop="" width="230" align="center" label="">
                <template slot-scope="scope">
                  <div>
                    <span class="nav" v-if="create1==user" @click="editColumn(scope.$index,scope.row)"
                      style="margin-right: 4px"> 编辑</span>
                    <span v-if="create1==user" style="color:#ebedf0;font-size: 20px;font-weight: 100">|</span>
                    <span class="nav" v-if="create1==user" @click="delColumn(scope.$index,scope.row)"
                      style="color:red;margin-left: 4px"> 删除</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>

            <!-- 分页组件 -->
            <Pagination v-if="total > 0" :currentPage="currentPage" :total="total" :limit="limit"
              @handleCurrentChange="handleCurrentChange"></Pagination>
          </div>
        </div>
      </div>
    </div>

    <!--  查看详情  -->
    <el-dialog :title="mytaskbyid1.name" :visible.sync="editFormVisible1" class="edit-dialog"
      :close-on-click-modal="false" :close-on-press-escape="false">
      <!--      头部信息      -->
      <div class="dialog-data1">
        <div class="dialog-data2">
          <div class="font-icon beijinyuan"><i class="el-icon-time"></i></div>
          <div style="width: 80px;">
            <template>
              <el-select class="minFont1" v-model="mytaskbyid1.status"
                @change="((value)=>{updateStatus(value, mytaskbyid1.id)})">
                <el-option v-for="items in typeList" :key="items.id" :label="items.name" :value="items.id">
                </el-option>
              </el-select>
            </template>
            <br />
            <span class="minFont">当前状态</span>
          </div>
        </div>
        <div class="dialog-data2">
          <div class="font-icon">
            <el-image :src="'https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png'"
              style="height: 40px;width:40px;border-radius: 50%" v-if="avatar.avatar1==''||avatar.avatar1==undefined">
            </el-image>
            <el-avatar :src=" avatar.avatar1.substr(0,4) == 'http' ? avatar.avatar1 : $url.img + avatar.avatar1"
              @error="errorHandler"
              :key=" avatar.avatar1.substr(0,4) == 'http' ? avatar.avatar1 : $url.img + avatar.avatar1" v-else>
            </el-avatar>

          </div>
          <div><span class="minFont1">{{ mytaskbyid1.charger_name }}</span><br /><span class="minFont">负责人</span></div>
        </div>
        <div class="dialog-data2">
          <div class="font-icon beijinyuan"><i class="el-icon-date"></i></div>
          <div><span class="minFont1">{{ mytaskbyid1.start_time }}</span><br /><span class="minFont">开始时间</span>
          </div>
        </div>
        <div class="dialog-data2">
          <div class="font-icon beijinyuan"><i class="el-icon-folder-checked"></i></div>
          <div>
            <el-date-picker class="minFont1" @change="updateTime(mytaskbyid1.id,mytaskbyid1.project_id)"
              v-model="mytaskbyid1.end_time" value-format="yyyy-MM-dd" type="date" :picker-options="pickerOptions1"
              placeholder="选择日期">
            </el-date-picker>
            <br /><span class="minFont">结束时间</span>
          </div>
        </div>
      </div>
      <el-divider></el-divider>
      <!--     分割线下的信息       -->
      <el-form :inline="true" class="demo-form-inline form-text">
        <el-form-item label="项目名称">
          <el-input disabled v-model="mytaskbyid1.name"></el-input>
        </el-form-item>
        <el-form-item label="优先等级">
          <el-select v-model="priority1" @change="updateTa(mytaskbyid1.id,mytaskbyid1.project_id)">
            <el-option v-for="item in xuanze1" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <div style="height: 1px;width: 10px"></div>
        <el-form-item label="参与人" class="lefta">
          <span v-for="(t,index) in mytaskbyidTask" :key="index">
            <el-image :src="'https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png'"
              style="height: 40px;width:40px;border-radius: 50%;margin-left:5px"
              v-if="t.user_avatar==''||t.user_avatar==undefined"></el-image>
            <el-avatar :src="t.user_avatar.substr(0,4) == 'http' ? t.user_avatar : $url.img + t.user_avatar"
              :key="t.user_avatar.substr(0,4) == 'http' ? t.user_avatar : $url.img + t.user_avatar" v-else>
            </el-avatar>&nbsp;

          </span>
        </el-form-item>
        <el-form-item label="备注" class="lastitem">
          <el-input disabled v-model="mytaskbyid1.remark" :rows="2" type="textarea"></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>


    <!--  甘特图  -->
    <div v-if="showAss==2">
      <div class="work2">
        <div class="caozuo">
          <span @click="showAss=1">任务</span> &nbsp;&nbsp; <span
            style="color:#ebedf0;font-size: 20px;font-weight: 100">|</span>&nbsp;&nbsp;
          <span @click="showAss=2">甘特图</span>&nbsp;&nbsp;
          <el-button v-if="user == 1 || users2.indexOf(user) != -1" class="btn-submit" @click="editColumn"
            icon="el-icon-plus">新增
          </el-button>
        </div>
      </div>
      <gantt-elastic v-if="showTasks" :options="options" :tasks="tasks" class="gante">
      </gantt-elastic>
    </div>


    <!--  编辑或者新增  -->
    <el-dialog :title="title" :visible.sync="editFormVisible" class="edit-dialog5" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <el-form class="user-form" :model="userForm" :rules="rules" ref="userForm" label-width="80px">
        <el-form-item label="任务名称" prop="name" class="namea">
          <el-input v-model="userForm.name" maxlength="50" show-word-limit placeholder="请输入任务名称"></el-input>
        </el-form-item>
        <el-form-item label="负责人" prop="charger">
          <template>
            <el-select v-model="userForm.charger" @change="addUser1" placeholder="请选择成员">
              <el-option v-for="item1 in users" :key="item1.user_id" :label="item1.user_name" :value="item1.user_id">
              </el-option>
            </el-select>
          </template>
        </el-form-item>

        <el-form-item label="优先级" prop="priority">
          <el-select v-model="userForm.priority">
            <el-option v-for="role in xuanze" :key="role.value" :label="role.label" :value="role.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务周期" >
          <el-radio v-model="userForm.task_type" :label='1' @change="selectSingle">单次</el-radio>
          <el-radio v-model="userForm.task_type" :label='2' @change="selectPeriod">周期</el-radio>
        </el-form-item>
        <div v-if="isPeriod">
          <div style="display: flex;align-items: flex-start;">
          <el-form-item label="周期间隔" prop="cycle_interval" style="width:165px ;">
            <el-input v-model="userForm.cycle_interval" placeholder="请输入间隔时长" size="small" style="width:165px;"></el-input>
        </el-form-item>
        <el-form-item  prop="cycle_interval_unit" style="width:165px ;">
          <el-select v-model="userForm.cycle_interval_unit" placeholder="请选择" size="small" style="width:110px ;">
              <el-option  key="days" label="日" value="days"></el-option>
              <el-option  key="months" label="月" value="months"></el-option>
            </el-select>
        </el-form-item>
      </div>
        <el-form-item label="首次开始" prop="start_time">
          <el-date-picker v-model="userForm.start_time" type="date" @change="changeDate" :clearable="false"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        </div>
        <div v-else>
          <el-form-item label="开始时间" prop="start_time">
          <el-date-picker v-model="userForm.start_time" type="date" @change="changeDate" :clearable="false"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="截止时间" prop="end_time">
          <el-date-picker v-model="userForm.end_time" type="date" :picker-options="pickerOptions" :clearable="false"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        </div>
        <el-form-item label="参与人" prop="user_ids" >
          <template>
            <el-select v-model="userForm.user_ids" multiple filterable placeholder="请选择成员" @change="consoleinfo">
              <el-option v-for="item2 in users1" :key="item2.user_id" :label="item2.user_name" :value="item2.user_id">
              </el-option>
            </el-select>
          </template>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="userForm.remark" :autosize="{ minRows: 2, maxRows: 4}" :rows="5" type="textarea"
            placeholder="请添加备注" maxlength="500" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-submit" type="primary" @click="submitForm('userForm',1)">确定</el-button>
        <el-button class="btn-submit1" v-show="title === '新增'" @click="submitForm('userForm')">确定并继续创建</el-button>
      </div>
    </el-dialog>

    <!--  冲突警告  -->
    <el-dialog title="警告！以下内容与当前任务冲突,请确定是否继续创建" :visible.sync="dialogTableVisible" :close-on-click-modal="false">
      <el-table :data="gridData" :span-method="objectSpanMethod" border style="width: 100%; margin-top: 20px">
        <el-table-column prop="msg" label="任务名">
        </el-table-column>
        <el-table-column prop="name" label="用户名" width="180">
        </el-table-column>

      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-cancel" type="primary" @click="dialogTableVisible = false">取消创建</el-button>
        <el-button class="btn-submit" @click="sub1('userForm')">确定创建</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import GanttElastic from "gantt-elastic";
import GanttHeader from "gantt-elastic-header";
import dayjs from "dayjs";
import Pagination from "../../components/Pagination";
import { gettastview } from "../../api/view";
import { getTasks, deletetask, addtask, updatetask, getUsers, getProjectbyid, checkaddupdate } from "../../api/myproject";
import { getstatuss, getUserList2 } from "../../api/setting";
import { getTasksbyid, updateST, updateTask } from "../../api/myTask";

// import {getstatuss} from "../../api/setting";

function getDate(hours) {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();
  const currentDay = currentDate.getDate();
  const timeStamp = new Date(
    currentYear,
    currentMonth,
    currentDay,
    0,
    0,
    0
  ).getTime();
  return new Date(timeStamp + hours * 60 * 60 * 1000).getTime();
}

let that;
let tasks = [
  {
    id: 1,
    label: "Make some noise",
    start: getDate(-24 * 5),
    duration: 4 * 24 * 60 * 60 * 1000,
    percent: 85,
    type: "milestone",
    collapsed: true,
  },
  {
    id: 2,
    label: "With great power comes great responsibility",
    start: getDate(-24 * 4),
    duration: 4 * 24 * 60 * 60 * 1000,
    percent: 50,
    type: "milestone",
    collapsed: true,
    style: {
      base: {
        fill: "#1EBC61",
        stroke: "#0EAC51",
      },
    },
  },
];
let options = {
  locale: {
    weekdays: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
    months: [
      "一月",
      "二月",
      "三月",
      "四月",
      "五月",
      "六月",
      "七月",
      "八月",
      "九月",
      "十月",
      "十一月",
      "十二月",
    ],
  },
  taskMapping: {
    progress: "percent",
  },
  maxRows: 100,
  maxHeight: 650,
  title: {
    label: "Your project title as html (link or whatever...)",
    html: true,
  },
  row: {
    height: 24,
  },
  calendar: {
    hour: {
      display: false,
    },
  },
  chart: {
    progress: {
      bar: false,
    },
    expander: {
      display: true,
    },
  },
  taskList: {
    expander: {
      straight: false,
    },
    columns: [
      {
        id: 1,
        label: "任务名称",
        value: "label",
        align: "center",
        width: 150,
        expander: true,
        html: true,
      },
      {
        id: 3,
        label: "状态",
        value: "Status",
        align: "center",
        html: true,
        width: 100,
      },
      {
        id: 4,
        label: "负责人",
        value: "charger_name",
        width: 120,
      },
    ],
  },
};
//进行中
let doingStyle = {
  base: {
    fill: "",
    stroke: "",
  },
};
//阻塞
let warnStyle = {
  base: {
    fill: "",
    stroke: "",
  },
};
//已完成
let finishStyle = {
  base: {
    fill: "",
    stroke: "",
  },
};
//未开始
let cancelStyle = {
  base: {
    fill: "",
    stroke: "",
  },
};
export default {
  name: "itemOne",
  data() {
    return {
      dialogTableVisible: false,
      gridData: [],
      //详情弹窗
      //单个任务详情数据
      mytaskbyid1: {},
      mytaskbyidTask: {},
      avatar: {
        avatar1: ''
      },
      // //状态下拉数据
      // typeList1: [],
      editFormVisible1: false,
      //获取每个弹窗的开始时间
      idTime1: '',
      //禁用当前时间之前的时间
      pickerOptions1: {
        disabledDate: (time) => {
          return time.getTime() < new Date((this.idTime1 + ' 00:00:00')).getTime() // 选当前时间之前的时间
        }
      },
      // 优先级
      priority1: '',
      //优先级
      xuanze1: [{
        value: '2',
        label: '加急'
      }, {
        value: '3',
        label: '最高'
      }, {
        value: '4',
        label: '较高'
      }, {
        value: '1',
        label: '普通'
      }],
      //value弹框
      hahavalue: '',
      //获取每个弹窗的开始时间
      idTime: '',
      //禁用当前时间之前的时间
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < new Date((this.userForm.start_time + ' 00:00:00')).getTime() // 选当前时间之前的时间
        }
      },
      activeName: '1',
      user: localStorage.getItem('userId'),
      username: localStorage.getItem("name"),
      doingStyle,
      finishStyle,
      warnStyle,
      cancelStyle,
      tasks,
      options,
      showTasks: false,
      typeList: [],
      mytaskbyid: {
        id: '',
        status: '',
        charger_name: ''
      },
      //处于哪个任务
      where: 1,
      //项目id
      id: 0,
      //用户列表
      users: [],
      users1: [],
      //  控制显示哪个组件
      showAss: 1,
      //显示表头
      showHeader: false,
      // 我的任务-表格数据
      tableData: [],
      //弹窗参数
      title: '新增',
      editFormVisible: false,
      userForm: {
        id: '',
        name: '',
        remark: '',
        charger: '',
        user_ids: [],
        priority: '',
        start_time: '',
        end_time: '',
        task_type:'',//任务类型
        cycle_interval:'',//周期间隔
        cycle_interval_unit:''//间隔单位
      },
      //优先级
      xuanze: [{
        value: '2',
        label: '加急'
      }, {
        value: '3',
        label: '最高'
      }, {
        value: '4',
        label: '较高'
      }, {
        value: '1',
        label: '普通'
      }],
      //  规则验证
      rules: {
        name: [{ required: true, message: '请输入任务名称', trigger: 'change' }],
        charger: [{ required: true, message: '请选择负责人', trigger: 'change' }],
        start_time: [{ required: true, message: '请选择开始日期', trigger: 'change' }],
        end_time: [{ required: true, message: '请选择结束日期', trigger: 'change' }],
        user_ids: [{ required: true, message: '请选择参与人', trigger: 'change' }],
        cycle_interval:[{ required: true, message: '请输入间隔时长', trigger: 'change' }],
        cycle_interval_unit:[{ required: true, message: '请选择间隔单位', trigger: 'change' }]
      },
      //状态是否小于3
      thStatus: 1,
      //状态名称
      staName: '',
      // 分页参数
      currentPage: 1,
      limit: 10,
      total: 0,
      //项目创建人
      create1: 0,
      //获取单个项目参与人
      users2: [],
      isPeriod:true //是否选择了周期
    }
  },
  methods: {
    //表格合并方法
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    //选择单次任务
    selectSingle(){
     this.isPeriod=false
    },
    //选择周期任务
    selectPeriod(){
      this.isPeriod=true
    },
    consoleinfo(){
      console.log('任务类型:'+this.userForm.task_type)
      console.log('周期间隔:'+this.userForm.cycle_interval)
      console.log('间隔单位:'+this.userForm.cycle_interval_unit)
    },
    //获取项目创建人,
    getUserItem() {
      let params = {
        token: localStorage.getItem("token"),
        id: this.id,
      };
      getProjectbyid(params).then((res) => {
        if (res.errno === 0) {
          this.create1 =res.data.creator
          this.users2 = (res.data.user_ids).split(',')
        } else if (res.errno === 401) {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        } else {
          this.$message.error(res.data);
        }
      });
    },
    //新增方法
    errorHandler() {
      return true
    },
    errorHandler1() {
      return true
    },
    //修改时间
    updateTime(id, project_id) {
      let params = {
        token: localStorage.getItem("token"),
        id: id,
        project_id: project_id,
        end_time: this.dateFormat('YYYY-mm-dd', this.mytaskbyid1.end_time)
      };
      if ((new Date((this.mytaskbyid1.end_time).toString().replace(/-/g, "/"))) >= (new Date((this.mytaskbyid1.start_time).toString().replace(/-/g, "/")))) {

        updateTask(params).then((res) => {
          if (res.errno === 0) {
            this.$message({
              message: '时间修改成功',
              type: 'success'
            });
          } else if (res.errno === 401) {
            this.$store.dispatch("LogOut").then(() => {
              location.reload(); // 为了重新实例化vue-router对象 避免bug
            });
          } else {
            this.$message.error(res.data);
          }
        });
      } else {
        this.$message({
          message: '结束时间不得小于开始时间',
          type: 'error'
        });
      }
    },
    //修改优先级
    updateTa(id, project_id) {
      let params = {
        token: localStorage.getItem("token"),
        id: id,
        project_id: project_id,
        priority: this.priority1,
      };
      updateTask(params).then((res) => {
        if (res.errno === 0) {
          this.$message({
            message: '优先等级修改成功',
            type: 'success'
          });
        } else if (res.errno === 401) {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        } else {
          this.$message.error(res.data);
        }
      });
    },
    //打开详情-获取单个任务
    open(id) {
      this.editFormVisible1 = true
      let params = {
        token: localStorage.getItem("token"),
        id: id
      };
      getTasksbyid(params).then((res) => {
        if (res.errno === 0) {
          this.mytaskbyid1 = res.data
          this.avatar.avatar1 = res.data.charger_avatar
          this.idTime1 = res.data.start_time
          this.mytaskbyidTask = res.data.taskuser
          this.priority1 = res.data.priority == 1 ? '普通' : res.data.priority == 2 ? '加急' : res.data.priority == 3 ? '最高' : '较高'
        } else if (res.errno === 401) {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        } else {
          this.$message.error(res.error);
        }
      });
    },

    //获取每一行的颜色
    // getColor(item) {
    //   if (parseInt(item.status) < 3) {
    //     this.thStatus = 2
    //   } else {
    //     for (let type1 in this.allstatu) {
    //       if (item.status == this.allstatu[type1].id) {
    //         this.staName = this.allstatu[type1].name
    //         return this.allstatu[type1].color
    //       }
    //     }
    //   }
    // },
    //自动添加负责人
    addUser1() {
      this.userForm.user_ids = []
      this.userForm.user_ids.push(this.userForm.charger)
    },
    //改变开始时间
    changeDate(val) {
      if (val !== '' || val !== null) {
        this.userForm.start_time = this.dateFormat('YYYY-mm-dd', val)
      }
    },
    //格式化日期
    dateFormat(fmt, date) {
      let ret = "";
      date = new Date(date);
      const opt = {
        'Y+': date.getFullYear().toString(), // 年
        'm+': (date.getMonth() + 1).toString(), // 月
        'd+': date.getDate().toString(), // 日
        'H+': date.getHours().toString(), // 时
        'M+': date.getMinutes().toString(), // 分
        'S+': date.getSeconds().toString() // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      }
      for (let k in opt) {
        ret = new RegExp('(' + k + ')').exec(fmt)
        if (ret) {
          fmt = fmt.replace(
            ret[1],
            ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0')
          )
        }
      }
      return fmt
    },
    //获取用户列表
    getUser() {
      let params = {
        token: localStorage.getItem("token"),
        project_id: this.id
      };
      getUsers(params).then((res) => {
        if (res.errno === 0) {
          this.users = res.data
          this.users1 = res.data

        } else if (res.errno === 401) {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //编辑状态
    updateStatus(val, id) {
      let params = {
        token: localStorage.getItem("token"),
        id: id,
        status: val
      };
      updateST(params).then((res) => {
        if (res.errno === 0) {
          this.$message({
            message: '状态修改成功',
            type: 'success'
          });
          this.getTasks2(this.where)
          this.getData()
        } else if (res.errno === 401) {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //提交
    submitForm(formName, val) {
      if(this.isPeriod){
        let validTest=this.userForm.name&&this.userForm.charger&&this.userForm.start_time&&this.userForm.user_ids&&this.userForm.cycle_interval&&this.userForm.cycle_interval_unit
        if(validTest){
          val == 1 ? this.hahavalue = 1 : this.hahavalue = ''
          this.sub1(formName, val)
        }
        else{
          this.$refs[formName].validateField(['name','charger','start_time','user_ids','cycle_interval','cycle_interval_unit'])
        }        
      }
      else{
        this.$refs[formName].validate((valid) => {
        if (valid) {
          val == 1 ? this.hahavalue = 1 : this.hahavalue = ''
          let pa = {
            token: localStorage.getItem("token"),
            user_ids: (this.userForm.user_ids).toString(),
            start_time: this.dateFormat('YYYY-mm-dd', this.userForm.start_time),
            end_time: this.dateFormat('YYYY-mm-dd', this.userForm.end_time),
            id: this.userForm.id,
          }
          checkaddupdate(pa).then((res) => {
            if (res.errno === 0 || res.errno === 20041) {
              if (res.errno === 0) {
                this.sub1(formName, val)
              } else {
                this.dialogTableVisible = true
                this.gridData = res.data
              }
            } else if (res.errno === 401) {
              this.$store.dispatch("LogOut").then(() => {
                location.reload(); // 为了重新实例化vue-router对象 避免bug
              });
            } else {
              this.$message.error(res.error);
            }
          });

        }
      })
      }
    },
    sub1(formName, val) {
      if (this.title == '新增') {
        let params={}
        if(this.isPeriod){
           params = {
            token: localStorage.getItem('token'),
            name: this.userForm.name,
            remark: this.userForm.remark,
            project_id: this.id,
            priority: this.userForm.priority,
            charger: this.userForm.charger,
            user_ids: (this.userForm.user_ids).toString(),
            start_time: this.dateFormat('YYYY-mm-dd', this.userForm.start_time),
            end_time: '',
            task_type:this.userForm.task_type,
            cycle_interval:this.userForm.cycle_interval,
            cycle_interval_unit:this.userForm.cycle_interval_unit
          }
        }
        else{
          if ((new Date((this.userForm.end_time).toString().replace(/-/g, "/"))) >= (new Date((this.userForm.start_time).toString().replace(/-/g, "/")))) {
            params = {
            token: localStorage.getItem('token'),
            name: this.userForm.name,
            remark: this.userForm.remark,
            project_id: this.id,
            priority: this.userForm.priority,
            charger: this.userForm.charger,
            user_ids: (this.userForm.user_ids).toString(),
            task_type:this.userForm.task_type,
            start_time: this.dateFormat('YYYY-mm-dd', this.userForm.start_time),
            end_time: this.dateFormat('YYYY-mm-dd', this.userForm.end_time)
          }
          }
          else{
            this.$message({
            type: "error",
            message: '截止时间不能小于开始时间'
          })
          return
          }
        }
        // if ((new Date((this.userForm.end_time).toString().replace(/-/g, "/"))) >= (new Date((this.userForm.start_time).toString().replace(/-/g, "/")))) {
        //   let params = {
        //     token: localStorage.getItem('token'),
        //     name: this.userForm.name,
        //     remark: this.userForm.remark,
        //     project_id: this.id,
        //     priority: this.userForm.priority,
        //     charger: this.userForm.charger,
        //     user_ids: (this.userForm.user_ids).toString(),
        //     start_time: this.dateFormat('YYYY-mm-dd', this.userForm.start_time),
        //     end_time: this.dateFormat('YYYY-mm-dd', this.userForm.end_time)
        //   }
          addtask(params).then(res => {
            if (res.errno === 0) {
              this.$message({
                type: "success",
                message: res.data
              })
              if (this.showAss == 2) {
                this.getData()
              }
              if (this.hahavalue == 1) {
                this.editFormVisible = false

                this.getTasks2(this.where)
              } else {
                this.userForm.id = '',
                  this.userForm.name = '',
                  this.userForm.remark = '',
                  this.userForm.charger = '',
                  this.userForm.user_ids = [],
                  this.userForm.priority = '',
                  this.userForm.start_time = this.dateFormat('YYYY-mm-dd', new Date()),
                  this.userForm.end_time = ''
                  this.userForm.task_type='2'
                  this.userForm.cycle_interval=''
                  this.userForm.cycle_interval_unit=''
                this.getTasks2(this.where)
              }
            } else if (res.errno === 401) {
              this.$store.dispatch('LogOut').then(() => {
                location.reload() // 为了重新实例化vue-router对象 避免bug
              })
            } else {
              this.$message.error(res.error)
            }
          })
        // } else {
        //   this.$message({
        //     type: "error",
        //     message: '截止时间不能小于开始时间'
        //   })
        // }
      } else {
        let params={}
        if(this.isPeriod){
           params = {
            id:this.userForm.id,
            token: localStorage.getItem('token'),
            name: this.userForm.name,
            remark: this.userForm.remark,
            project_id: this.id,
            priority:this.userForm.priority == '普通' ? 1 : this.userForm.priority == '加急' ? 2 : this.userForm.priority == '最高' ? 3 : 4,
            charger: this.userForm.charger,
            user_ids: (this.userForm.user_ids).toString(),
            start_time: this.dateFormat('YYYY-mm-dd', this.userForm.start_time),
            end_time: '',
            task_type:this.userForm.task_type,
            cycle_interval:this.userForm.cycle_interval,
            cycle_interval_unit:this.userForm.cycle_interval_unit
          }
        }
        else{
          if ((new Date((this.userForm.end_time).toString().replace(/-/g, "/"))) >= (new Date((this.userForm.start_time).toString().replace(/-/g, "/")))) {
            params = {
            id:this.userForm.id,
            token: localStorage.getItem('token'),
            name: this.userForm.name,
            remark: this.userForm.remark,
            project_id: this.id,
            priority: this.userForm.priority == '普通' ? 1 : this.userForm.priority == '加急' ? 2 : this.userForm.priority == '最高' ? 3 : 4,
            charger: this.userForm.charger,
            user_ids: (this.userForm.user_ids).toString(),
            task_type:this.userForm.task_type,
            start_time: this.dateFormat('YYYY-mm-dd', this.userForm.start_time),
            end_time: this.dateFormat('YYYY-mm-dd', this.userForm.end_time)
          }
          }
          else{
            this.$message({
            type: "error",
            message: '截止时间不能小于开始时间'
          })
          return
          }
        }
        // if ((new Date((this.userForm.end_time).toString().replace(/-/g, "/"))) >= (new Date((this.userForm.start_time).toString().replace(/-/g, "/")))) {

        //   let params = {
        //     token: localStorage.getItem('token'),
        //     id: this.userForm.id,
        //     name: this.userForm.name,
        //     remark: this.userForm.remark,
        //     project_id: this.id,
        //     priority: this.userForm.priority == '普通' ? 1 : this.userForm.priority == '加急' ? 2 : this.userForm.priority == '最高' ? 3 : 4,
        //     charger: this.userForm.charger,
        //     user_ids: (this.userForm.user_ids).toString(),
        //     start_time: this.dateFormat('YYYY-mm-dd', this.userForm.start_time),
        //     end_time: this.dateFormat('YYYY-mm-dd', this.userForm.end_time)
        //   }

          updatetask(params).then(res => {
            if (res.errno === 0) {
              this.$message({
                type: "success",
                message: res.data
              })
              // this.updateStatus(this.mytaskbyid.status, this.mytaskbyid.id)
              if (this.hahavalue == 1) {
                this.editFormVisible = false
                this.getTasks2(this.where)
              } else {
                this.getTasks2(this.where)
              }
            } else if (res.errno === 401) {
              this.$store.dispatch('LogOut').then(() => {
                location.reload() // 为了重新实例化vue-router对象 避免bug
              })
            } else {
              console.log('enter!!!')
              this.$message.error(res.data)
            }
          })
        // } else {
        //   this.$message({
        //     type: "error",
        //     message: '截止时间不能小于开始时间'
        //   })
        // }
      }
      this.dialogTableVisible = false
    },
    //获取项目任务列表
    getTasks2(tab) {
      let params = {
        page: this.currentPage,
        token: localStorage.getItem("token"),
        project_id: this.id,
        tab: parseInt(tab), //默认打开全部
      };
      console.log(params);
      getTasks(params).then((res) => {
        if (res.errno === 0) {
          this.where = tab
          this.tableData = res.data.data
          this.tableData.forEach((item, index) => {
            this.allstatu.forEach((sta, staIndex) => {
              if (item.status == sta.id) {
                item.staName = sta.name
                item.staColor = sta.color

              }
            })
          })


          this.limit = res.data.per_page
          this.total = res.data.total
        } else if (res.errno === 401) {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //删除
    delColumn(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          id: row.id,
          token: localStorage.getItem('token')
        }
        deletetask(params).then(res => {
          if (res.errno === 0) {
            this.$message({
              type: 'success',
              message: res.data
            })
            this.getTasks2(this.where)
          } else if (res.errno === 401) {
            this.$store.dispatch('LogOut').then(() => {
              location.reload() // 为了重新实例化vue-router对象 避免bug
            })
          } else {
            this.$message.error(res.error)
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('删除失败,请稍后再试！')
        })
      }).catch(err => {
        this.loading = false
      })
    },
    // 编辑或者新增
    editColumn(index, row) {
      this.editFormVisible = true
      if (row == '' || row == undefined) {
        this.userForm.id = 0,
          this.userForm.name = '',
          this.userForm.remark = '',
          this.userForm.charger = '',
          this.userForm.user_ids = [],
          this.userForm.priority = '',
          this.userForm.start_time = this.dateFormat('YYYY-mm-dd', new Date()),
          this.userForm.end_time = '',
          this.userForm.task_type=2
        this.title = '新增'
      } else {
        this.title = '编辑',
          this.userForm.id = row.id,
          console.log(this.userForm.id);
          this.mytaskbyid.status = row.status,
          this.mytaskbyid.id = row.id,
          this.mytaskbyid.charger_name = row.charger_name
        this.userForm.name = row.name,
          this.userForm.remark = row.remark,
          this.userForm.charger = row.charger,
          this.userForm.user_ids = row.user_ids == '' || row.user_ids == null ? [] : row.user_ids.split(',').map(Number)
        this.userForm.priority = row.priority == 1 ? '普通' : row.priority == 2 ? '加急' : row.priority == 3 ? '最高' : '较高',
          this.userForm.start_time = this.dateFormat('YYYY-mm-dd', row.start_time),
          this.userForm.end_time = this.dateFormat('YYYY-mm-dd', row.end_time),
          this.userForm.cycle_interval=row.cycle_interval,
          this.userForm.cycle_interval_unit=row.cycle_interval_unit,
          this.userForm.task_type=row.task_type
          if(this.userForm.task_type==1){
            this.isPeriod=false
          }
          else{this.isPeriod=true}
      }
    },
    //翻页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTasks2(this.activeName)
      this.getUser()
    },
    //切换项目
    // fetchData() {
    //   this.id = this.$route.query.id
    //   this.getUserItem()
    //   this.showAss = 1
    //   this.showTasks = false
    //   this.getData()
    //   this.getUser()
    //   this.getAllData()
    //   // this.getUserItem()
    //
    // },
    async fetchData() {
      this.id = this.$route.query.id
      this.allstatu = await this.getstatu()
      this.getTasks2(1)
      this.showAss = 1
      this.showTasks = false
      this.getData()
      this.getUser()
      this.getUserItem()
    },
    getData() {
      let params = {
        token: localStorage.getItem("token"),
        project_id: this.id
      };
      gettastview(params).then((res) => {
        if (res.errno === 0) {
          var temp = JSON.parse(JSON.stringify(res.data.task))
          this.tasks = [];
          var sum = 0;
          if (temp != "") {
            for (var i in temp) {
              if (temp[i].id == "" || temp[i].id == undefined) {
                continue;
              } else {
                temp[i].start_time = new Date(
                  temp[i].start_time.replace(/-/g, "/")
                );
                temp[i].end_time = new Date(
                  temp[i].end_time.replace(/-/g, "/")
                );
                if (temp[i].status == 3) {

                } else {
                  sum += 1;
                  var obj = {
                    charger_name: temp[i].charger_name,
                    id: sum,
                    test_id: temp[i].id,
                    label: temp[i].name,
                    user: temp[i].user_ids,
                    start: new Date(temp[i].start_time).getTime(),
                    end: new Date(temp[i].end_time).getTime(),
                    Status: temp[i].status,
                    duration:
                      new Date(temp[i].end_time).getTime() -
                      new Date(temp[i].start_time),
                    type: "milestone",
                    percent: 100,
                  };
                  for (var m in this.allstatu) {
                    let lcsd = {
                      base: {
                        fill: "",
                        stroke: "",
                      },
                    };
                    if (temp[i].status == this.allstatu[m].id) {
                      lcsd.base.fill = this.allstatu[m].color;
                      lcsd.base.stroke = this.allstatu[m].color;
                      obj.style = lcsd;
                      if (this.allstatu[m].id == 1) {
                        obj.Status = '<span class="begin1" style="background-color:' + this.allstatu[m].color + '">' + this.allstatu[m].name + "</span>";
                      } else if (this.allstatu[m].id == 2) {
                        obj.Status = '<span class="jingxing1">' + this.allstatu[m].name + "</span>";

                      } else if (this.allstatu[m].id == 3) {
                        obj.Status = '<span class="finished1">' + this.allstatu[m].name + "</span>";
                      } else {
                        obj.Status = '<span class="rest" style="background-color:' + this.allstatu[m].color + '">' + this.allstatu[m].name + "</span>";
                      }
                      this.tasks.push(obj);
                    }
                  }
                }

              }
            }
          }
          if (this.tasks.length > 0 && this.showAss == 2) {
            this.showTasks = true;
          }
        } else if (res.errno === 401) {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        } else {
          this.$message.error(res.error);
        }
      });
    },
    clickto() {
      this.showAss = 2;
      if (this.tasks.length > 0) {
        this.showTasks = true
      }
    },
    //状态颜色
    getstatu() {
      return new Promise((resolve, reject) => {
        let params = {
          token: localStorage.getItem("token"),
          page: this.currentPage3,
        };
        getstatuss(params).then((res) => {
          if (res.errno === 0) {
            this.typeList = res.data.data;
            resolve(res.data.data)
          } else if (res.errno === 401) {
            this.$store.dispatch("LogOut").then(() => {
              location.reload(); // 为了重新实例化vue-router对象 避免bug
            });
          } else {
            this.$message.error(res.errno);
          }
        });
      })
    },
  },
  mounted() {
    //获取项目id
    this.id = this.$route.query.id
    //获取项目创建人
    // this.getUserItem()
    // this.getData()
    // this.getUser()
    // this.getAllData()
    // this.getUserItem()
    var self = this;
    self.fetchData();
  },

  // 注册组件
  components: {
    Pagination,
    GanttElastic,
    GanttHeader,
  },
  watch: {
    '$route': 'fetchData'
  },
}
</script>


<style scoped>
/*  table栏切换开始 */
.god {
  height: 100%;
  background-color: #ffffff;
}

.god1 {
  height: auto;
  background-color: #ffffff;
}

.q-pa-sm {
  background-color: #fbfbfb;
}

.el-tabs .el-tabs--top {
  width: 100%;
}

.q-pa-sm>>>.el-tabs__header {
  padding-left: 30px;
  background-color: #ffffff;
}

.q-pa-sm>>>.el-tabs__nav-wrap::after {
  content: '';
  background-color: revert;
}

.q-pa-sm>>>.el-tabs__nav {
  height: 60px;
}

.q-pa-sm>>>.el-tabs__item.is-active {
  color: #141464;
  font-size: 17px;
  font-weight: 700;
}

.q-pa-sm>>>.el-tabs__item {
  color: #666666;
}

.q-pa-sm>>>.el-tabs__active-bar {
  background-color: #2b52e9;
}

.q-pa-sm>>>.el-tabs--top .el-tabs__item.is-top:last-child {
  padding-right: 0;
  height: 60px;
  line-height: 60px;
}

.q-pa-sm>>>.el-tabs__item {
  font-size: 16px;
}

.work {
  position: relative;
  margin-bottom: 30px;
}

.work2 {
  position: relative;
  width: 100%;
  height: 60px;
  margin-bottom: 30px;
  background-color: #ffffff;
}

.caozuo {
  position: absolute;
  right: 60px;
  top: 15px;
  cursor: pointer;
  font-size: 16px;
  color: #2b51e8;
}

/*  table栏切换结束 */

/* 表格开始 */
/* .work1 {
} */

.work1>>>.el-table td,
.el-table th {
  padding: 5px 0;
}

/*未开始*/
.begin1 {
  display: block;
  width: 62px;
  line-height: 25px;
  height: 25px;
  margin: 0 auto;
  color: #7747df;
  background-color: #f2edfc;
  border-radius: 15px;
}

/*.work1 >>> .begin1 .el-table_1_column_1 .cell {*/
/*  width: 70px;*/
/*  height: 25px;*/
/*  margin: 0 auto;*/
/*  color: #7747df;*/
/*  background-color: #f2edfc;*/
/*  border-radius: 15px;*/
/*}*/

.redfont {
  color: #ff606d;
}

.nav {
  cursor: pointer;
  color: #2b52e9;
}

/*未开始结束*/

/*进行中*/
.jingxing1 {
  display: block;
  width: 65px;
  line-height: 25px;
  height: 25px;
  margin: 0 auto;
  color: #41bfd6;
  background-color: #ebf9fc;
  border-radius: 15px;
}

/*.work1 >>> .jingxing1 .el-table_1_column_1 .cell {*/
/*  width: 70px;*/
/*  height: 25px;*/
/*  margin: 0 auto;*/
/*  color: #41bfd6;*/
/*  background-color: #ebf9fc;*/
/*  border-radius: 15px;*/
/*}*/

/*.work1 >>> .jingxing1 .el-table_1_column_3 .cell {*/
/*  color: #ff606d;*/
/*}*/

/*进行中结束*/

/*已完成*/
.finished1 {
  display: block;
  width: 65px;
  line-height: 25px;
  height: 25px;
  margin: 0 auto;
  color: #5ec16c;
  background-color: #e8faeb;
  border-radius: 15px;
}

.finished2 {
  color: #b3b3b3;
}

.elseTask {
  display: block;
  width: 65px;
  line-height: 25px;
  height: 25px;
  margin: 0 auto;
  color: #606060;
  border-radius: 15px;
}

/*.work1 >>> .finished1 .el-table_1_column_1 .cell {*/
/*  width: 70px;*/
/*  height: 25px;*/
/*  margin: 0 auto;*/
/*  color: #5ec16c;*/
/*  background-color: #e8faeb;*/
/*  border-radius: 15px;*/
/*}*/

/*.work1 >>> .finished1 .el-table_1_column_3 .cell,*/
/*.work1 >>> .finished1 .el-table_1_column_2 .cell {*/
/*  color: #b3b3b3;*/
/*}*/

/*已完成结束*/


/*按钮*/
.btn-edit1 {
  color: #2b51e8;
  background-color: #ffffff;
  border: none;
  font-size: 14px;
  border-radius: unset;
  width: 50px;
  border-right: 1px solid #ebedf0;
}

.btn-del11 {
  color: #ff606d;
  background-color: #ffffff;
  border: none;
  margin: unset;
  font-size: 14px;
  border-radius: unset;
  width: 50px;
}

/* 表格结束 */

/* 弹窗 */
.edit-dialog5>>>.el-dialog__body {
  padding: 30px 70px;
}

.edit-dialog5>>>.el-textarea__inner {
  /*width: 720px;*/
  /*height: 64px;*/
  font-size: 12px;
  border-radius: unset;
  border: 1px solid #cccccc;
}

.edit-dialog5>>>.el-select {
  width: 60%;
}

.edit-dialog5>>>.el-select .el-input__inner {
  width: 100%;
}

.edit-dialog5>>>.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 60%;
}

.namea>>>.el-input {
  width: 60%;
}

.edit-dialog5>>>.el-input__inner {
  /*width: 360px;*/
  height: 32px;
  font-size: 12px;
  color: #999999;
  border-radius: unset;
  border: 1px solid #cccccc;
}

.edit-dialog5>>>.el-input__inner:hover,
.edit-dialog5>>>.el-textarea__inner:hover {
  border: 1px solid #b0bceb;
  font-size: 12px;
}

.edit-dialog5>>>.el-input__inner:focus,
.edit-dialog5>>>.el-textarea__inner:focus {
  border: 1px solid #2b52e9;
  font-size: 12px;
  color: #333333;
}


/* 弹窗结束 */

/* 确定按钮 */

.el-button.btn-submit {
  background: #2b52e9;
  border-color: #2b52e9;
  color: #fff;
  width: 80px;
  height: 32px;
}

.el-button.btn-submit1 {
  background: #ebf2fc;
  border-color: #2b52e9;
  color: #2b52e9;
  width: 160px;
  height: 32px;
}

/* 导航栏 */
/* 居中 */
.gante>>>.gantt-elastic__task-list-item-value-container {
  margin: auto !important;
  text-align: center !important;
}

.gante>>>.gantt-elastic__task-list-item-value {
  line-height: 2em !important;
}

.gante>>>.gantt-elastic__task-list-header-column {
  text-align: center;
  background-color: #f5f5f5 !important;
}

.gante>>>.gantt-elastic__calendar {
  background-color: #f5f5f5 !important;
}

/* 进行中 */
.gante>>>.jingxing1 {
  display: block;
  width: 65px;
  line-height: 25px;
  height: 25px;
  margin: 0 auto;
  color: #41bfd6;
  background-color: #ebf9fc;
  border-radius: 15px;
}

/*未开始 */
.gante>>>.begin1 {
  display: block;
  width: 62px;
  line-height: 25px;
  height: 25px;
  margin: 0 auto;
  color: #7747df;
  background-color: #f2edfc;
  border-radius: 15px;
}


/* 已完成 */
.gante>>>.finished1 {
  display: block;
  width: 65px;
  line-height: 25px;
  height: 25px;
  margin: 0 auto;
  color: #5ec16c;
  background-color: #e8faeb;
  border-radius: 15px;
}

/* 其余状态颜色 */
.gante>>>.rest {
  display: block;
  width: 65px;
  line-height: 25px;
  height: 25px;
  margin: 0 auto;
  /* color: #5ec16c;
  background-color: #e8faeb; */
  border-radius: 15px;
}

/* 弹出层 */
.q-pa-sm>>>.el-dialog {
  width: 50%;
  min-height: 400px;
}

.minFont {
  color: #888888;
  font-size: 14px;
}

.minFont1 {
  color: #333333;
  font-size: 16px;
}

.el-dialog__header {
  padding: 45px 20px 10px;
}

.form-text {
  display: flex;
  position: relative;
  justify-content: space-between;
  flex-wrap: wrap;
  text-decoration: none;
  margin: 0 50px;
}


.edit-dialog>>>.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 10px;
  width: 46.5%;
  vertical-align: top;
}

.q-pa-sm>>>.el-dialog__title {
  font-size: 20px;
  color: #141464;
  font-weight: 700;
}

.q-pa-sm>>>.el-dialog__headerbtn {
  top: 3px;
  right: 3px;
  font-size: 25px;
}


.edit-dialog>>>.el-input.is-disabled,
.edit-dialog>>>.el-input__inner {
  width: 100%;
  height: 32px;
  background-color: #ffffff;
  border-color: #cccccc;
  color: #666666;
  border-radius: unset;
}

.edit-dialog>>>.el-select .el-input__inner {
  cursor: pointer;
}

.edit-dialog>>>.el-textarea__inner {
  /*width: 330px;*/
  background-color: #ffffff;
  border-color: #cccccc;
  color: #666666;
  border-radius: unset;
}

.lefta {
  margin-left: 13px;
}

.lefta>>>.el-form-item__content {
  max-width: 260px;
}

.beijinyuan {
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  background-color: #f2f6ff;
}

.beijinyuan>>>i {
  position: relative;
  left: 8px;
  top: 2px;
  color: #2b51e8;
}

/*.leftb{*/
/*  position: absolute;*/
/*  top: 62px;*/
/*  left: 12px;*/
/*}*/

.dialog-data1 {
  display: flex;
  justify-content: space-between;
  padding: 0 50px;
}

.dialog-data2 {
  display: flex;
  flex-wrap: wrap;
}

.font-icon {
  font-size: 26px !important;
  margin-right: 10px;
}

.min-data i {
  font-size: 17px;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 160px;
  color: #ff606d;
  cursor: pointer !important;
}

.dialog-data2>>>.el-input__inner {
  border: none;
  padding: 0;
  width: 120px;
  font-size: 16px;
  height: 21px;
  color: #ff606d;
  cursor: pointer !important;
}

.lastitem>>>.el-form-item__content {
  width: 85%;
}

.dialog-data2>>>.el-select span,
.dialog-data2>>>.el-date-editor span {
  display: none;
}

.el-table {
  margin-top: 35px;
}

.wangle>>>input {
  border: none !important;
  padding: 0 !important;
  width: 80px;
  border-radius: unset;
  background: none;
  font-size: 16px;
}

.wangle>>>span {
  display: none;
}

.q-pa-sm>>>.el-form-item__label {
  padding: 0 14px 0 0;
}

.lastitem>>>.el-form-item__label {
  margin-left: 4px;
}

.edit-dialog .el-input__inner:focus,
.edit-dialog .el-textarea__inner:focus {
  color: #ff606d !important;
  font-size: 16px;
}

.q-pa-sm>>>.el-image,
.q-pa-sm>>>.el-avatar {
  float: right;
}

.q-pa-sm>>>td:nth-child(4) .cell {
  padding-right: 0;
}
</style>
<style>
.jinggaoya {
  width: 50% !important;
}
</style>



// WEBPACK FOOTER //
// src/views/myproject/itemOne.vue